import { Validators } from '@angular/forms';
import { hasNumberValidator } from './has-number.validator';

/*
 * "Safe" password validator. Obviously not true, as passwords are inherently unsafe.
 * But if this makes our clients feel less agitated and sleep better at night, then so be it.
 *
 * Please document every added requirement for passwords below:
 *
 * "should consist of at least 6 characters, at least one of which should be a number"
 * https://ridango.atlassian.net/browse/SUP-70320
 */
export const passwordValidator = Validators.compose([Validators.required, Validators.minLength(6), hasNumberValidator]);
